import type { AppEnv } from '@hoppy-hour/game-config';

export const environment = {
  env: 'dev-remote' as AppEnv,
  production: false,
  supabaseUrl: 'https://achgmusiekvrpthatbgc.supabase.co',
  supabaseAnonKey: 'sb_publishable_D_FpUenaGULlEZlASJrbVg_AqD8n_nE',
  apiUrl: 'https://api-development-d7e4.up.railway.app/api',
};
